<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_user_app']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="appCode">
              <a-select v-model="model.appCode"
                        :placeholder="language['common.pleaseChoose'] + language['gift_user_app']" :disabled='appLimit.limit' >
                <a-select-option v-for='(v,k) in appLimit.appCodeNameMap' :key='k' :value='k' :label='v'>
                    {{v}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['category']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="category">
              <a-input v-model="model.category" :placeholder="language['common.pleaseInput']+language['category']"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift.qa.q']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="question">
              <a-textarea maxlength='500'  :auto-size="{ minRows: 2, maxRows: 5 }" v-model="model.question" :placeholder="language['common.pleaseInput']+language['gift.qa.q']"  ></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift.qa.a']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="answer">
              <a-textarea maxlength='500'  :auto-size="{ minRows: 2, maxRows: 5 }" v-model="model.answer" :placeholder="language['common.pleaseInput']+language['gift.qa.a']"  ></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'QaForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      appLimit:{
        limit:false,
        appCodeNameMap:[],
        activeAppCode: undefined,
      },
    },
    data () {
      const language = this.$store.getters.language;
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           appCode: [
              { required: true, message: language['common.pleaseChoose'] + language['gift_user_app']},
           ],
           category: [
              { required: true, message: language['common.pleaseInput']+language['category']},
           ],
           question: [
              { required: true, message: language['common.pleaseInput']+language['gift.qa.q']},
           ],
           answer: [
              { required: true, message: language['common.pleaseInput']+language['gift.qa.a']},
           ],
        },
        url: {
          add: "/carnival/qa",
          edit: "/carnival/qa",
          queryById: "/carnival/qa/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
        if (this.appLimit.limit){
          this.model.appCode = this.appLimit.activeAppCode;
          this.$forceUpdate();
        }
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
